import { IntlShape } from 'react-intl';
import { withViewModel } from '../../../../../../../infrastructure/components/with-view-model';
import { EmailsTemplateFormVM } from '../emails-template-form.viewmodel';
import CreateEmailTemplateViewModel from './create-email-template-form.viewmodel';
import { CreateEmailsTemplateFormPresentation } from './create-emails-template-form-presentation';

interface IProps {
    vm: EmailsTemplateFormVM;
    intl: IntlShape;
}

const CreateEmailTemplatesFormContainer = withViewModel(
    CreateEmailsTemplateFormPresentation,
    (props: IProps) => {
        const {
            vm,
            intl,
        } = props;

        return new CreateEmailTemplateViewModel(vm, intl);
    }
);

export { CreateEmailTemplatesFormContainer as CreateEmailTemplatesForm };
